export default function transformLinks(links) {
  return links.map(link => {
    const { props, ...rest } = link;

    if (props) {
      return { ...JSON.parse(props), ...rest }
    }

    return rest;
  })
}